// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme--light.v-radio--is-disabled label {
  color: rgba(0,0,0,0.38);
}
.theme--light.v-radio--is-disabled .v-icon {
  color: rgba(0,0,0,0.26) !important;
}
.theme--dark.v-radio--is-disabled label {
  color: rgba(255,255,255,0.5);
}
.theme--dark.v-radio--is-disabled .v-icon {
  color: rgba(255,255,255,0.3) !important;
}
.v-radio {
  align-items: center;
  display: flex;
  height: auto;
  margin-right: 16px;
  outline: none;
}
.v-radio--is-disabled {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/components/_radios.styl"],"names":[],"mappings":"AAKI;EACE,uBAAsB;AAJ5B;AAMI;EAEE,kCAAyB;AAL/B;AAAI;EACE,4BAAsB;AAE5B;AAAI;EAEE,uCAAyB;AAC/B;AAGA;EACE,mBAAa;EACb,aAAS;EACT,YAAQ;EACR,kBAAc;EACd,aAAS;AADX;AAGE;EACE,oBAAgB;AADpB","sourcesContent":["@import '../bootstrap'\n@import '../theme'\n\nv-radio($material)\n  &--is-disabled\n    label\n      color: $material.text.disabled\n\n    .v-icon\n      // needed for helper override\n      color: $material.buttons.disabled !important\n\ntheme(v-radio, \"v-radio\")\n\n.v-radio\n  align-items: center\n  display: flex\n  height: auto\n  margin-right: 16px\n  outline: none\n\n  &--is-disabled\n    pointer-events: none\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
